import React from 'react';

const Privacy = () => {
  return (
    <div className="container" style={{ textAlign: 'left', lineHeight: '1.8' }}>
      <h1>개인정보 처리방침</h1>
      <p>최종 수정일: 2024년 7월 29일</p>

      <h2>1. 총칙</h2>
      <p>
        '나와 꼭 맞는 두바이 쫀득쿠키는?'(이하 '사이트')는 귀하의 개인정보를 매우 중요하게 생각하며, '정보통신망 이용촉진 및 정보보호 등에 관한 법률' 및 '개인정보보호법' 등 관련 법률을 준수하고 있습니다. 본 개인정보 처리방침을 통해 귀하가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
      </p>

      <h2>2. 수집하는 개인정보 항목 및 수집 방법</h2>
      <p>
        본 사이트는 별도의 회원가입 절차 없이 모든 콘텐츠에 자유롭게 접근할 수 있습니다. 퀴즈 이용 시 선택하는 답변이나 결과는 서버에 저장되지 않으며, 오직 귀하의 브라우저 내에서만 일시적으로 처리됩니다. 따라서, 저희 사이트는 귀하를 식별할 수 있는 어떠한 개인정보(이름, 이메일 주소, 연락처 등)도 수집하지 않습니다.
      </p>
      <p>
        다만, 서비스 이용 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다:
        <ul>
          <li>IP 주소, 쿠키, 서비스 이용 기록, 방문 기록, 불량 이용 기록 등</li>
        </ul>
      </p>

      <h2>3. 쿠키(Cookie)에 의한 개인정보 수집</h2>
      <p>
        본 사이트는 제3자 광고 서비스인 Google AdSense를 사용하고 있습니다. Google AdSense는 사용자에게 더욱 관련성 높은 광고를 제공하기 위해 쿠키를 사용합니다.
      </p>
      <ul>
        <li>Google을 포함한 제3자 광고 사업자는 쿠키를 사용하여 사용자의 이전 웹사이트 방문 기록을 기반으로 광고를 게재합니다.</li>
        <li>Google은 광고 쿠키를 사용하여 파트너 사이트(애드센스 광고가 게재된 사이트, Google 인증 광고 네트워크 회원사 등) 방문 기록을 기반으로 사용자에게 맞춤 광고를 표시할 수 있습니다.</li>
        <li>사용자는 <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google 광고 설정</a>에서 맞춤 광고 게재를 거부할 수 있습니다. 또한, <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">aboutads.info/choices</a> 페이지에서 제3자 광고 사업자의 맞춤 광고 쿠키 사용을 선택 해제할 수 있습니다.</li>
      </ul>
      <p>
        귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
      </p>

      <h2>4. 개인정보의 처리 목적</h2>
      <p>
        자동으로 수집되는 비식별 정보는 서비스의 안정적인 운영, 통계 분석, 광고 수익 모델의 유지 및 개선, 사용자의 서비스 이용 경험 향상을 위한 목적으로 사용됩니다.
      </p>

      <h2>5. 개인정보의 보유 및 이용기간</h2>
      <p>
        본 사이트는 개인정보를 수집하지 않으므로, 별도로 보유 및 파기하는 개인정보가 없습니다. 자동으로 수집된 비식별 정보는 관련 법령에 따라 일정 기간 보관될 수 있습니다.
      </p>
      
      <h2>6. 개인정보의 제3자 제공</h2>
      <p>
        본 사이트는 귀하의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우는 예외입니다.
      </p>

      <h2>7. 개인정보 처리방침의 변경</h2>
      <p>
        현 개인정보 처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다.
      </p>

      <h2>8. 문의</h2>
      <p>
        개인정보 처리방침에 대한 문의사항이 있으시면 아래 연락처로 문의해 주시기 바랍니다.
        <br />
        <strong>이메일:</strong> djkcookie3800@gmail.com
      </p>
    </div>
  );
};

export default Privacy;